
import React from 'react';
import {
  Form, Icon, Input, Button,
} from 'antd';
import PropTypes from 'prop-types';
import QualitasLogo from '../assets/logoQualitas.png';
import { Box } from '../../shared/components';

function NormalLoginForm(props) {
  const { form, loading, onSubmit } = props;
  const { getFieldDecorator } = form;
  const color = { color: 'rgba(0,0,0,.25)' };
  return (
    <Box verticalAlign="middle">
      <Box pt={8} pb={8}>
        <img src={QualitasLogo} style={{ maxWidth: '280px', display: 'block', margin: 'auto auto' }} />
      </Box>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          form.validateFields((err, values) => {
            if (!err) {
              onSubmit(values);
            }
          });
        }}
        className="login-form"
      >
        <Form.Item required={false} label="DOMINIO">
          {getFieldDecorator('dominio', {
            rules: [
              { required: true, message: 'Introduzca el dominio' }],
          })(
            <Input
              readOnly={loading}
            />,
          )}
        </Form.Item>

        <Form.Item required={false} label="USUARIO">
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Introduzca el usuario' }],
          })(
            <Input
              readOnly={loading}
            />,
          )}
        </Form.Item>

        <Form.Item required={false} label="CONTRASEÑA">
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Introduzca la contraseña' }],
          })(
            <Input
              readOnly={loading}
              type="password"
            />,
          )}
        </Form.Item>

        <Form.Item>
          <Box py={2}>
            <Button style={{ height: '50px' }} block loading={loading} type="primary" htmlType="submit" className="login-form-button">
            Entrar
            </Button>
          </Box>
        </Form.Item>
      </Form>
    </Box>
  );
}
/* eslint react/forbid-prop-types: 0 */
NormalLoginForm.propTypes = {
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

const LoginFormComponent = Form.create({ name: 'normal_login' })(NormalLoginForm);
export default LoginFormComponent;
